import { Button, Card, EmptyState } from "@helmr/ui";
import { Component, type ReactNode } from "react";
import { strings } from "./strings";

function Crashed() {
  return (
    <Card>
      <EmptyState icon="alert" title={strings.states.crashTitle} description={strings.states.crashBody} action={<Button onClick={() => window.location.reload()}>{strings.states.reload}</Button>} />
    </Card>
  );
}

/** For a route's `errorElement`. */
export const RouteError = Crashed;

export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (!this.state.failed) return this.props.children;
    return <Crashed />;
  }
}
